<template>
  <div><strong><em>Reseting izidok application data, please wait...</em></strong></div>
</template>

<script>
export default {
  data: () => {
    return {
      beingSubmit: false
    };
  },
  name: "Reset",
  mounted() {
    let ls = ['_izd_'];
    let qls = this.$route.query.ls;

    if(!Array.isArray(qls)) {
      qls = [qls];
    }

    ls = ls.concat(qls);

    ls.forEach(item => {
      localStorage.removeItem(item)
    })

    window.history.back();
  },
};
</script>